import Info from '@mui/icons-material/Info'
import { IconButton } from '@mui/material'
import {
  UAPDayItemEventDetailsContainer,
  UAPDayItemEventDetailsSubtitle,
  UAPDayItemEventDetailsTitle,
  UAPDayItemEventParent,
  UAPDayItemEventsContainer,
} from '../../MyPlanStyles'
import { capitalizeSentence } from 'src/shared/utils/textUtils'

export function PlannedActivitiesLister({
  plannedActivity,
  active,
  passed,
  todaysActivityIndex,
  setupData,
  onClickInfoButton,
}) {
  const mainPlannedActivity = plannedActivity?.plannedActivity

  function renderActivity(key = plannedActivity?.id, activityObject, isMain = false) {
    return (
      <UAPDayItemEventsContainer>
        <UAPDayItemEventParent>
          <UAPDayItemEventDetailsContainer>
            <div
              className={`d-flex flex-column ${active ? 'gap-2' : 'gap-2'} ${
                plannedActivity?.highlightTitle ? 'align-items-center' : ''
              } w-100`}
            >
              {plannedActivity?.planItemIdx === todaysActivityIndex && active && (
                <div className="d-flex justify-content-between align-items-center">
                  <UAPDayItemEventDetailsSubtitle>
                    TODAY&apos;S ACTIVITY
                  </UAPDayItemEventDetailsSubtitle>
                  <IconButton onClick={onClickInfoButton} sx={{ color: '#5fc7ff' }}>
                    <Info />
                  </IconButton>
                </div>
              )}
              <UAPDayItemEventDetailsTitle
                active={active}
                highlight={plannedActivity?.highlightTitle}
              >
                {capitalizeSentence(activityObject?.activityTitle)}
              </UAPDayItemEventDetailsTitle>
              {activityObject?.customCategoryTitle && (
                <UAPDayItemEventDetailsSubtitle>
                  <span>
                    {activityObject?.customCategoryTitle?.charAt(0)?.toUpperCase() +
                      activityObject?.customCategoryTitle?.slice(1)}
                  </span>
                </UAPDayItemEventDetailsSubtitle>
              )}
            </div>
            {/* <MPDayItemEventPicture src={getImageLink(plannedActivity?.coverIcon)} /> */}
          </UAPDayItemEventDetailsContainer>
        </UAPDayItemEventParent>
      </UAPDayItemEventsContainer>
    )
  }

  return (
    <div style={{ width: '100%', opacity: passed ? 0.7 : 1, zIndex: 1 }}>
      {renderActivity(undefined, mainPlannedActivity, true)}
    </div>
  )
}

/* <Collapse in={showOtherActivities}>
          {otherActivities?.map((otherActivity, otherActivityIndex) => {
            return renderActivity(
              `${plannedActivity?.id}-${otherActivityIndex}`,
              otherActivity,
              false,
            )
          })}
        </Collapse> */
/* <div className="d-flex w-100 justify-content-end algin-items-center">
          {otherActivities?.length > 0 && (
            <UAPShowOtherActivitiesButton onClick={toggleShowOtherActivities}>
              <ExpandMore sx={{ transform: !showOtherActivities ? 'unset' : 'rotate(180deg)' }} />
              {showOtherActivities ? 'View Less' : 'View More'}
            </UAPShowOtherActivitiesButton>
          )}
        </div> */
